module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-light.490a3422.svg";